import { createContext, PropsWithChildren, useState } from 'react';

export const OrderManagementProvider = ({ children }: PropsWithChildren) => {
  const [isLoadingInitialOrder, setIsLoadingInitialOrder] = useState<boolean>(false);

  return (
    <OrderManagementContext.Provider value={{ isLoadingInitialOrder, setIsLoadingInitialOrder }}>
      {children}
    </OrderManagementContext.Provider>
  );
};

export const OrderManagementContext = createContext<{
  isLoadingInitialOrder: boolean;
  setIsLoadingInitialOrder: (isLoading: boolean) => void;
}>({
  isLoadingInitialOrder: true,
  setIsLoadingInitialOrder: () => {},
});
